import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { AlertTriangle, ExternalLink } from "lucide-react";
import { NeuButton, NeuCard } from "../../components/neu/Neu";

export const ExpiryTable = ({ alerts }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  if (!alerts.length)
    return (
      <p className="text-sm text-muted-foreground" data-testid="docs-empty">
        {t("docs.none")}
      </p>
    );

  return (
    <div className="grid gap-3" data-testid="docs-table">
      {alerts.map((a) => (
        <NeuCard key={`${a.user_id}-${a.kind}`} className="p-4" data-testid={`docs-row-${a.user_id}-${a.kind}`}>
          <div className="flex flex-wrap items-center justify-between gap-3">
            <div className="min-w-0">
              <p className="truncate font-bold">{a.name}</p>
              <p className="text-xs text-muted-foreground">
                {t(`docs.types.${a.kind}`, t(`docs.${a.kind === "passport" ? "passport" : "nationalId"}`))} · {a.number || "—"} · {a.expiry}
              </p>
            </div>
            <div className="flex items-center gap-3">
              <span
                className={`flex items-center gap-1 rounded-full px-3 py-1 text-xs font-bold ${
                  a.days_left < 0 ? "bg-danger/10 text-danger" : "bg-warning/10 text-warning"
                }`}
              >
                <AlertTriangle className="h-3.5 w-3.5" />
                {a.days_left < 0 ? t("docs.expired", { days: Math.abs(a.days_left) }) : t("docs.daysLeft", { days: a.days_left })}
              </span>
              <NeuButton
                className="flex items-center gap-2 px-4 py-2"
                data-testid={`docs-open-${a.user_id}`}
                onClick={() => navigate(`/employees/${a.user_id}`)}
              >
                <ExternalLink className="h-4 w-4" /> {t("docs.open")}
              </NeuButton>
            </div>
          </div>
        </NeuCard>
      ))}
    </div>
  );
};
